/**
 * Accessory slot 2 of three. Trinkets, pouches and dosimeters: worn gear that shifts a stat or
 * carries a small plate rather than covering a hit location outright.
 */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const ACCESSORY_2_SLOT = {
  id: 'accessory2',
  label: 'Accessory 2',
  description: 'Worn gear that is not a plate: pouches, filters and charms.',
} as const satisfies EquipmentSlot;
